import { createSlice, isPending, isFulfilled, isRejected } from '@reduxjs/toolkit'

const initialState = {
  activeRequests: 0,
  isProcessing: false
}

const IGNORED_ACTIONS = [
    'appCommonReducers/GetSearchAgent'
    // 'appCommonReducers/GetRefreshData',
    // 'analytics/LogAnalyticsEvent'
]
const shouldTrack = (actionType) => !IGNORED_ACTIONS.some((prefix) => actionType.startsWith(prefix))

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setProcessing: (state, action) => {
      state.isProcessing = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state, action) => {
        if (!shouldTrack(action.type)) return
        state.activeRequests += 1
        // Do NOT set isProcessing here – handled in middleware after 500ms
      })
      .addMatcher(isFulfilled, (state, action) => {
        if (!shouldTrack(action.type)) return
        state.activeRequests = Math.max(0, state.activeRequests - 1)
        // state.isProcessing = state.activeRequests > 0
      })
      .addMatcher(isRejected, (state, action) => {
        if (!shouldTrack(action.type)) return
        state.activeRequests = Math.max(0, state.activeRequests - 1)
        // state.isProcessing = state.activeRequests > 0
      })
  }
})

export const { setProcessing } = uiSlice.actions
export default uiSlice.reducer